import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePinInputClass;
function SavePinInput() {
  if (SavePinInputClass === VOID) {
    class $ {
      constructor(partyId, pinId, icon, name) {
        this.partyId_1 = partyId;
        this.pinId_1 = pinId;
        this.icon_1 = icon;
        this.name_1 = name;
      }
      toString() {
        return 'SavePinInput(partyId=' + this.partyId_1.toString() + ', pinId=' + this.pinId_1.toString() + ', icon=' + this.icon_1 + ', name=' + this.name_1 + ')';
      }
      hashCode() {
        var result = this.partyId_1.hashCode();
        result = imul(result, 31) + this.pinId_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.icon_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePinInput()))
          return false;
        if (!this.partyId_1.equals(other.partyId_1))
          return false;
        if (!this.pinId_1.equals(other.pinId_1))
          return false;
        if (!(this.icon_1 === other.icon_1))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePinInput');
    SavePinInputClass = $;
  }
  return SavePinInputClass;
}
//region block: exports
export {
  SavePinInput as SavePinInputnc3r3ek8pldn,
};
//endregion

//# sourceMappingURL=SavePinInput.mjs.map
